import { Theme } from '@mui/system'
import { makeStyles } from '@mui/styles'

import { FONTS, SPACES } from 'src/constants'

const useStyles = makeStyles((theme: Theme) => ({
  notification: {
    '&&': {
      [theme.breakpoints.down('tablet')]: {
        bottom: 78,
      },
    },
  },
  notificationWrapper: {
    '&&': {
      borderRadius: 10,
      display: 'flex',
      gap: SPACES.xl,
      alignItems: 'center',
      padding: SPACES.xxxs,
      backgroundColor: theme.palette.custom.grey,
    },
  },
  notificationMessageWrapper: {
    '&&': { display: 'flex', alignItems: 'center', gap: SPACES.m },
  },
  iconWrapper: {
    paddingLeft: 10,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  notificationIcon: {
    '&&': {
      color: theme.palette.custom.darkBlue2,
      width: 20,
      height: 20,
    },
  },
  notificationText: {
    '&&': { fontWeight: FONTS.WEIGHTS.bold, color: theme.palette.custom.darkBlue2 },
  },
}))

export { useStyles }
